import { authGet, authPost, authPut } from '../../api';
import { camelizeKeys } from 'humps';
import { normalize } from 'normalizr';
import * as schema from './schema';

const Product = {
  async get(slug: string | number) {
    const response = await authGet(`/api/v1/variants/${slug}`);
    const data = await response.json().then(b => camelizeKeys(b));

    const responseProduct = await authGet(`/v2/products/${data?.id}`);
    const animalData = await responseProduct.json().then(b => camelizeKeys(b));

    ({ animal: data.animal, cut: data.cut, isGiftCard: data.isGiftCard, storageCondition: data.storageCondition } = animalData);

    const normalized = normalize(data, schema.product);
    return normalized;
  },
  async putNotifyMe(productId: string | number) {
    const response = await authPut(`/api/v1/variants/${productId}/notify_me`);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.product);
    return normalized;
  },
  async putUnnotifyMe(productId: string | number) {
    const response = await authPut(`/api/v1/variants/${productId}/unnotify_me`);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.product);
    return normalized;
  },
  async getRecentlyViewedProductsRequest(slug: string | number) {
    const response = await authGet(`/v2/products/recently_viewed`);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },

  // TODO: Ids are now hard coded. Implement appropriate path
  async getRelatedProductsRequest(slug: string | number) {
    const ids = [121, 122, 123, 124, 13, 14, 16, 17, 22, 23, 33, 34];
    const response = await authGet(`/v2/products?by_id=[${ids}]`);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async getPromotionProductsRequest(page = 1, perPage = 10) {
    /*const ids = ;*/
    const response = await authGet(
      `/v2/products/?q[by_in_promotion]=true&q[purchasable]=true&q[discounted_not_eq]=true&page=${page}&per_page=${perPage}`,
    );
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async getProductsRecommendedForUserRequest(page = 1, perPage = 10) {
    const response = await authGet(
      `/v2/products/discounted/?page=${page}&per_page=${perPage}`,
    );
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async getMostSoldProductsRequest(page = 1, perPage = 20) {
    /*const ids = [129, 124, 128, 28, 20, 74, 51, 6];*/
    const response = await authGet(
      `/v2/products?q[s]=sales_volume+desc&q[discounted_not_eq]=true&q[purchasable]=true&page=${page}&per_page=${perPage}`,
    );
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async getFrequentlyPurchasedTogetherProductsRequest(
    variantId,
    page = 0,
    perPage = 10,
  ) {
    const response = await authGet(
      `/v2/products/${variantId}/frequently_purchased_together`,
    );
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async byIds(ids: number[]) {
    const response = await authGet(`/v2/products?by_id=[${ids}]`);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async bySubdepartment(subdepartmentId: string) {
    const response = await authGet(
      `/v2/products?by_subdepartment=${subdepartmentId}`,
    );
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.products);
    return normalized;
  },
  async getDisplayVariantsByPageAndSection(page: string, section: string) {
    const response = await authGet(
      `/v2/variant_displays?by_page=${page}${
        section ? `&by_section=${section}` : ''
      }`,
    );
    const data = await response.json().then(b => {
      return camelizeKeys(b);
    });
    const normalized = normalize(data, schema.displayVariants);
    return normalized;
  },
  async postCreateProductLinkByVariantId(variantId: number) {
    const body = {
      variant_id: variantId,
    };
    const response = await authPost('/v2/deep_link_user_variants', body);
    const data = await response.json().then(b => camelizeKeys(b));
    const normalized = normalize(data, schema.displayVariants);
    return normalized;
  },
};

export default Product;
